import React, { Component } from 'react';
import exm from './exm.png';
import load from './load.gif';
import './App.css';
import hero from './v1.json';
import Cookies from 'js-cookie';

function getImg(id){
    var url = "";
    for(var i = 0; i < hero.result.heroes.length; i++){
        if(parseInt(id) == hero.result.heroes[i].id){
            url = hero.result.heroes[i].img;
            break;
        }
    }

    if(url == undefined){
        url = "https://gamepedia.cursecdn.com/dota2_gamepedia/5/55/Pudge_minimap_icon.png?version=890c2a63b887f2d885caf173289981cc";
    }

    return url;
}

class List extends Component{
    constructor(){
        super();
    }

    handleChange(event){
        var url = "";
        for(var i = 0; i < hero.result.heroes.length; i++){
            if(parseInt(event.target.value) == hero.result.heroes[i].id){
                url = hero.result.heroes[i].img;
                break;
            }
        }

        if(url == undefined){
            url = "https://gamepedia.cursecdn.com/dota2_gamepedia/5/55/Pudge_minimap_icon.png?version=890c2a63b887f2d885caf173289981cc";
        }

        this.props.hero_ref.current.style.backgroundImage = `url("${url}")`;
        this.props.action(this.props.hero_id, this.props.hero_side, event.target.value);
    }

    componentDidMount(){
        
    }

    render(){
        return(
            <select onChange={this.handleChange.bind(this)} value={this.props.pre_selected}>
                <option>Hero</option>
                {hero.result.heroes.map((item, index) => <option onChange={this.handleChange} key={index} value={item.id}>{item.localized_name}</option>)}
            </select>
        );
    }
}

class Map extends Component{
    constructor(){
        super();
        this.rank = React.createRef();
    }

    componentDidMount(){
        let url = '';
        if(this.props.match.rank == -1){
            url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/e/e7/SeasonalRank0-0.png/230px-SeasonalRank0-0.png?version=6d3899e42d1569b076a3518934d42054';
        }else{
            switch(Math.floor(Math.floor(this.props.match.rank/10) - 1)){
                case 1:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/2/2b/SeasonalRank1-5.png/160px-SeasonalRank1-5.png?version=88a6558b73c5966745f7c04ccdd4d519';
                break;
                case 2:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/3/32/SeasonalRank2-5.png/160px-SeasonalRank2-5.png?version=22bbe284b2774aec70337fc99eb53c3a';
                break;
                case 3:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/b/b1/SeasonalRank3-5.png/160px-SeasonalRank3-5.png?version=f25682e8ba71eb2399d81062bee2e0e5';
                break;
                case 4:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/a/a3/SeasonalRank4-5.png/160px-SeasonalRank4-5.png?version=ace7dc976e3c1a3a7c1f0f66236f48a2';
                break;
                case 5:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/8/8e/SeasonalRank5-5.png/160px-SeasonalRank5-5.png?version=56e896b0ac5fb17a4945a49c82e0f92f';
                break;
                case 6:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/4/47/SeasonalRank6-5.png/160px-SeasonalRank6-5.png?version=a27cb94937ebbca56068e4d602889b88';
                break;
                case 1:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/3/33/SeasonalRank7-5.png/160px-SeasonalRank7-5.png?version=2fe403a83ca5b87e0223b33dc3178b56';
                break;
                case 8:
                    url = 'https://gamepedia.cursecdn.com/dota2_gamepedia/thumb/f/f2/SeasonalRankTop0.png/160px-SeasonalRankTop0.png?version=9c5a948ee2b1b9745cb7e5dfedee18e7';
                break;
            }
        }
        
        this.rank.current.style.backgroundImage = `url(${url})`;
    }

    render(){
        var hero_ = this.props.match.teamawin ? this.props.match.teama : this.props.match.teamb;

        return(
            <div className="match">
                <div className="match-id"><a target="_blank" href={'https://www.dotabuff.com/matches/'+this.props.match.match_id}>{'#'+this.props.match.match_id}</a></div>
                <div className="match-wrapper">
                    <div className="match-side">
                        <Side heroes={hero_} dis={true}/>
                    </div>
                    <div ref={this.rank} className="rank"></div>
                </div>
            </div>
        );
    }
}

class Side extends Component{
    constructor(props){
        super();
        
        this.hero = [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()]
    }

    componentDidMount(){
        if(this.props.heroes !== undefined){
            this.props.heroes.forEach((item, index) => {
                var url = "";
                for(var i = 0; i < hero.result.heroes.length; i++){
                    if(item == parseInt(hero.result.heroes[i].id)){
                        url = hero.result.heroes[i].img;
                        break;
                    }
                }

                if(url == undefined){
                    url = "https://gamepedia.cursecdn.com/dota2_gamepedia/5/55/Pudge_minimap_icon.png?version=890c2a63b887f2d885caf173289981cc";
                }

                this.hero[index].current.style.backgroundImage = `url("${url}")`;
            });
        }
    }

    focusOn(ref){
        console.log();
    }

    render(){
        let classNm = 'side';
        if(this.props.dis) classNm += ' dis';
        return(
            <div className={classNm}>
                <div className="side__name">
                    {this.props.name}
                </div>
                <div className="side__wrapper">
                    <div onClick={() => {this.focusOn(this.hero[0])}} type="text" className="hero-select" style={{backgroundImage: `url(${getImg(this.props.heroes[0])})`}} ref={this.hero[0]}>
                        {!this.props.dis ? <List pre_selected={this.props.heroes[0]} hero_ref={this.hero[0]} hero_id={0} hero_side={this.props.name} action={this.props.click.bind(this)}/> : ''}
                    </div>
                    <div onClick={this.props.click} type="text" className="hero-select" style={{backgroundImage: `url(${getImg(this.props.heroes[1])})`}} ref={this.hero[1]}>
                        {!this.props.dis ? <List pre_selected={this.props.heroes[1]} hero_ref={this.hero[1]} hero_id={1} hero_side={this.props.name} action={this.props.click.bind(this)}/> : ''}
                    </div>
                    <div onClick={this.props.click} type="text" className="hero-select" style={{backgroundImage: `url(${getImg(this.props.heroes[2])})`}} ref={this.hero[2]}>
                        {!this.props.dis ? <List pre_selected={this.props.heroes[2]} hero_ref={this.hero[2]} hero_id={2} hero_side={this.props.name} action={this.props.click.bind(this)}/> : ''}
                    </div>
                    <div onClick={this.props.click} type="text" className="hero-select" style={{backgroundImage: `url(${getImg(this.props.heroes[3])})`}} ref={this.hero[3]}>
                        {!this.props.dis ? <List pre_selected={this.props.heroes[3]} hero_ref={this.hero[3]} hero_id={3} hero_side={this.props.name} action={this.props.click.bind(this)}/> : ''}
                    </div>
                    <div onClick={this.props.click} type="text" className="hero-select" style={{backgroundImage: `url(${getImg(this.props.heroes[4])})`}} ref={this.hero[4]}>
                        {!this.props.dis ? <List pre_selected={this.props.heroes[4]} hero_ref={this.hero[4]} hero_id={4} hero_side={this.props.name} action={this.props.click.bind(this)}/> : ''}
                    </div>
                </div>
            </div>
        );
    }
}

class App extends Component{
    url = 'https://api.opendota.com/api/findMatches?teamA[]=67&teamA[]=23&teamA[]=98&teamA[]=35&teamA[]=84&teamB[]=42&teamB[]=74&teamB[]=53&teamB[]=90&teamB[]=86';
    skill_url = 'https://api.opendota.com/api/matches/';
    skill_url_pl = 'https://api.opendota.com/api/players/';

    constructor(){
        super();
        this.heroInput = React.createRef();
        this.heroFind = React.createRef();
        this.state = {
            side: [[-1, -1, -1, -1, -1],[-1, -1, -1, -1, -1]],
            matches: [],
            loading: false,
            disabled: true,
            used: false,
            night: 0
        };
    }

    componentDidMount(){
        var imageList = [load, exm];
        imageList.forEach((image) => {
            new Image().src = image
        });

        hero.result.heroes.sort(function(a, b){
            if(a.localized_name < b.localized_name) { return -1; }
            if(a.localized_name > b.localized_name) { return 1; }
            return 0;
        });

        if(typeof Cookies.get('night') === undefined){
            Cookies.set('night', false, {expires: 7});
        }else{
            this.setState({
                night: Cookies.get('night') == 'true' ? true : false
            }, () => {
                console.log(Cookies.get('night'), this.state.night);
                if(this.state.night){
                    document.getElementsByTagName('body')[0].classList.add('night');
                    document.getElementsByClassName('night-mode-button')[0].classList.add('day');
                }else{
                    document.getElementsByClassName('night-mode-button')[0].classList.remove('day');
                }
            });
        }

        if(Cookies.get('side') != undefined){
            this.state.side = JSON.parse(Cookies.get('side'));
            this.forceUpdate();
        }

        var data = this.state.side[0].concat(this.state.side[1]);
        var valid = true;

        data.forEach(item => {
            if(item == -1){
                valid = false;
            }
        });

        if(!valid){
            this.setState({
                disabled: true
            });
        }else{
            this.setState({
                disabled: false
            });
        }
    }

    heroClick(hero_id, side, hero_abs_id){
        side = side == "The Dire" ? 1 : 0;
        this.state.side[side][hero_id] = hero_abs_id;
        this.forceUpdate();
        var data = this.state.side[0].concat(this.state.side[1]);
        var valid = true;

        data.forEach(item => {
            if(item == -1){
                valid = false;
            }
        });

        if(!valid){
            this.setState({
                disabled: true
            });
        }else{
            this.setState({
                disabled: false
            });
        }
        Cookies.set('side', JSON.stringify(this.state.side), {expires: 7});
    }

    getSkill(match){
        fetch(this.skill_url+match.match_id).then(response => response.json())
        .then(data => {
            var pl = [];

            data.players.forEach(item => {
                if(item.account_id != null){
                    pl.push(fetch(this.skill_url_pl+item.account_id).then(item => item.json()));
                }
            });

            Promise.all(pl).then(data => {
                var rank = 0;
                data.forEach(item => {
                    rank += item.rank_tier;
                })

                rank = rank/data.length;

                this.cur_load += 1;

                this.state.matches.push({...match, rank: rank});
                this.state.loading = 0;
                this.state.used = true;
                this.forceUpdate();
            });


        })
    }

    getData(){
        if(this.state.loading == 1 || this.state.disabled) return;

        this.setState({
            loading: 1,
            matches: []
        });

        fetch(`https://api.opendota.com/api/findMatches?teamA[]=${this.state.side[0][0]}&teamA[]=${this.state.side[0][1]}&teamA[]=${this.state.side[0][2]}&teamA[]=${this.state.side[0][3]}&teamA[]=${this.state.side[0][4]}&teamB[]=${this.state.side[1][0]}&teamB[]=${this.state.side[1][1]}&teamB[]=${this.state.side[1][2]}&teamB[]=${this.state.side[1][3]}&teamB[]=${this.state.side[1][4]}`).then(response => response.json())
        .then(match => {
            this.need_load = match.length;
            if(match.length == 0){
                this.setState({
                    loading: 0,
                    disabled: 0
                });
                return;
            }
            match.forEach(item => {
                this.getSkill(item);
            });
        });
    }

    toggle_mode(){
        this.setState({
            night: !this.state.night
        }, () => {
            Cookies.set('night', this.state.night.toString(), {expires: 7});
            if(this.state.night){
                document.getElementsByTagName('body')[0].classList.add('night');
                document.getElementsByClassName('night-mode-button')[0].classList.add('day');
            }else{
                document.getElementsByTagName('body')[0].classList.remove('night');
                document.getElementsByClassName('night-mode-button')[0].classList.remove('day');
            }
        });
    }

    componentWillMount(){
        
    }
    render() {
        
        let button_active = "";
        if(this.state.loading == 1 || this.state.disabled) button_active = 'disabled';

        return (
            <div className="App">
                <div className="logo">
                    COMMUNITY MATCH WINNER FINDER
                    <div className="logo__sub">Powered for TI 10 Battle Pass</div>
                </div>
                <img src={exm} className="exm" />
                <div id="ads"></div>
                <div className="side-wrapper">
                    <input id="inv-input" ref={this.heroInput}></input>
                    <Side heroes={this.state.side[0]} name={"The Radiant"} click={this.heroClick.bind(this)} />
                    <div className="sideName">
                        <div className="sideName__name">Safe</div>
                        <div className="sideName__name">Mid</div>
                        <div className="sideName__name">Hard</div>
                        <div className="sideName__name">Soft</div>
                        <div className="sideName__name">Support</div>
                    </div>
                    <Side heroes={this.state.side[1]} name={"The Dire"} click={this.heroClick.bind(this)} />
                    <div onClick={() => this.getData()} id="find" className={button_active} ref={this.heroFind}>FIND</div>
                </div>
                <div className="response-wrapper">
                    {this.state.matches.map((item, index) => <Map match={item} key={index} />)}
                    {this.state.loading == 1 ? <div className="load"><div className="load__name">Searching</div><img src={load} /></div> : ''}
                </div>

                <div className="PS-sub" style={{display: 'none'}}>
                    Today's match cannot be found
                </div>
                <div onClick={this.toggle_mode.bind(this)} className="night-mode-button day">
                    <div className="night-mode">

                    </div>
                    <div className="night-name">
                        
                    </div>
                </div>
                <footer>
                    Powered by <strong>zone muter</strong>
                </footer>
            </div>
        );
    }
}

export default App;